var React = require('react');

function LogoYoutube (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.8 4.98334C15.6 3.68278 15 2.78239 13.6 2.5823C11.4 2.18213 8 2.18213 8 2.18213C8 2.18213 4.6 2.18213 2.4 2.5823C1 2.78239 0.3 3.68278 0.2 4.98334C0 6.2839 0 8.18473 0 8.18473C0 8.18473 0 10.0855 0.2 11.3861C0.4 12.6867 1 13.5871 2.4 13.7872C4.6 14.1873 8 14.1873 8 14.1873C8 14.1873 11.4 14.1873 13.6 13.7872C15 13.487 15.6 12.6867 15.8 11.3861C16 10.0855 16 8.18473 16 8.18473C16 8.18473 16 6.2839 15.8 4.98334ZM6 11.186V5.18343L11 8.18473L6 11.186Z","fill":"#318EFF"}));
}

LogoYoutube.defaultProps = {"width":"16","height":"17","viewBox":"0 0 16 17","fill":"none"};

module.exports = LogoYoutube;

LogoYoutube.default = LogoYoutube;
